// frontend/src/hooks/useStats.js
import { useState, useCallback, useEffect } from 'react';
import { fetchStatsAPI } from '../services/api';
import { useAuth } from './useAuth';

export const useStats = (shouldFetch = false) => { // Parameter, um Laden zu steuern
  const [statsData, setStatsData] = useState({
    topLocations: [],
    topGenres: [],
    totalBooks: 0,
    booksByLocation: [],
    booksWithoutCover: 0,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const { handleApiError } = useAuth();

  const fetchAllStats = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      // Definiere die Endpunkte
      const endpoints = [
        'top-locations',
        'top-genres',
        'book-count',
        'books-by-location',
        'books-without-cover',
      ];

      // Führe alle Anfragen parallel aus
      const responses = await Promise.all(
        endpoints.map(endpoint => fetchStatsAPI(endpoint))
      );

      // Verarbeite die Antworten
      const [
        topLocationsData,
        topGenresData,
        bookCountData,
        booksByLocationData,
        booksWithoutCoverData,
      ] = responses;

      setStatsData({
        topLocations: topLocationsData || [],
        topGenres: topGenresData || [],
        totalBooks: bookCountData?.totalBooks || 0,
        booksByLocation: booksByLocationData || [],
        booksWithoutCover: booksWithoutCoverData?.booksWithoutCover || 0,
      });

    } catch (err) {
      handleApiError(err);
      setError(err.message);
      // Setze Daten zurück oder behalte alte? Hier zurücksetzen:
      setStatsData({
        topLocations: [],
        topGenres: [],
        totalBooks: 0,
        booksByLocation: [],
        booksWithoutCover: 0,
      });
    } finally {
      setIsLoading(false);
    }
  }, [handleApiError]); // Abhängigkeit von handleApiError

  // Effekt zum Laden, wenn shouldFetch true ist
  useEffect(() => {
    if (shouldFetch) {
      fetchAllStats();
    }
  }, [shouldFetch, fetchAllStats]); // Abhängigkeit von shouldFetch und fetchAllStats

  return { statsData, isLoading, error, fetchAllStats };
};
